import React from 'react';
import type { GameStatus, Winner } from '../types/dualGame';

interface GameHUDProps {
  timeRemaining: number;
  status: GameStatus;
  winner: Winner;
  leftScore?: number;
  rightScore?: number;
  onPause: () => void;
  onReset: () => void;
}

export const GameHUD: React.FC<GameHUDProps> = ({
  timeRemaining,
  status,
  winner,
  onPause,
  onReset,
}) => {
  const formatTime = (seconds: number): string => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${String(secs).padStart(2, '0')}`;
  };

  const getStatusText = (): string => {
    switch (status) {
      case 'countdown': return '准备...';
      case 'playing': return '游戏进行中';
      case 'paused': return '游戏已暂停';
      case 'finished':
        if (winner === 'draw') return '平局！';
        return winner ? (winner === 'left' ? '左玩家获胜！' : '右玩家获胜！') : '游戏结束';
      default: return '';
    }
  };

  const getTimerClass = (): string => {
    if (timeRemaining <= 10) return 'timer urgent';
    if (timeRemaining <= 30) return 'timer warning';
    return 'timer';
  };

  return (
    <div className="game-hud">
      <div className="hud-left">
        <button
          className="hud-btn pause-btn"
          onClick={onPause}
          disabled={status === 'finished' || status === 'countdown'}
        >
          {status === 'playing' ? '⏸ 暂停' : status === 'paused' ? '▶ 继续' : '⏸'}
        </button>
        <button className="hud-btn reset-btn" onClick={onReset}>
          ↺ 重置
        </button>
      </div>

      <div className="hud-center">
        <div className={getTimerClass()}>
          <span className="timer-label">剩余时间</span>
          <span className="timer-value">{formatTime(timeRemaining)}</span>
        </div>
        <div className={`status-text ${status}`}>
          {getStatusText()}
        </div>
      </div>

      <div className="hud-right">
        <div className="help-hint">
          <span className="key">P</span>
          <span className="desc">暂停</span>
        </div>
      </div>
    </div>
  );
};

export default GameHUD;
